// Index is the root js file
import 'babel-polyfill';
import './fonts.scss';

import React from 'react';
import ReactDom from 'react-dom';
import {Route, HashRouter as Router} from 'react-router-dom';
import {createStore, applyMiddleware, compose, combineReducers} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {Provider} from 'react-redux';
import Modal from 'react-modal';

import {rootSaga} from './store/rootSaga';

// i18n
import {IntlProvider, addLocaleData} from 'react-intl';
import locale_en from 'react-intl/locale-data/en';

import message_en from './translation/en.json';

import './index.scss';

import {homeReducer} from './store/reducers/home.reducer';
import {authReducer} from './store/reducers/auth.reducer';

import App from './App';

addLocaleData([...locale_en]);
Modal.setAppElement('#app');

// Redux and Redux saga config
const sagaMiddleware = createSagaMiddleware();
const reduxDevTools =
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__();
const store = createStore(
    combineReducers({
        homeReducer,
        // autoCompleteSearchReducer,
        // searchReducer,
        // seeAllReducer,
        authReducer
    }),
    compose(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);
// Adding Router in provider
ReactDom.render(
    <IntlProvider locale={'en'} messages={message_en}>
    <Router>
        <Provider store={store}>
                <App />
        </Provider>
    </Router>
    </IntlProvider>,
    document.getElementById('app')
);
